import { Box, Typography } from '@mui/material'

import { styles } from './sandbox-banner.styles'

const SandboxBanner = () => {
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.text}>
        This is a Hapana Sandbox environment — data here is for testing purposes only
      </Typography>
    </Box>
  )
}

export default SandboxBanner
